const Save = (key, data) => {
    window.localStorage.setItem(key, JSON.stringify(data));
}

const Get = key => {
    return JSON.parse(window.localStorage.getItem(key));
}

const GetString = key => {
    return window.localStorage.getItem(key);
}

const Remove = key => {
    window.localStorage.removeItem(key);
}

export default {
    Save,
    Get,
    GetString,
    Remove
}